import React from "react";
import { DropdownButton } from "../../../components/buttons/dropdownButton";
import { HiOutlineDotsVertical, HiOutlineTrash } from "react-icons/hi";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { BiDetail } from "react-icons/bi";
import { TbEdit } from "react-icons/tb";
import { IoShareSocial } from "react-icons/io5";
import { RxDownload } from "react-icons/rx";

const FileAndFolderAction = ({
  doc = null,
  onView = () => null,
  onDetails = () => null,
  onRename = () => null,
  onDelete = () => null,
  onShare = () => null,
  onDownload = () => null,
  access = "",
}) => {
 

    
  const dropdownItems = [
    {
      name: (
        <div className="flex items-center flex-row gap-2">
          <MdOutlineRemoveRedEye /> View
        </div>
      ),
      onClick: () => onView(doc),
    },
    {
      name: (
        <div className="flex items-center flex-row gap-2">
          <BiDetail />
          Detail
        </div>
      ),
      onClick: () => onDetails(doc),
    },
    {
      name: (
        <div className="flex items-center flex-row gap-2">
          <TbEdit />
          Rename
        </div>
      ),
      onClick: () => onRename(doc.id),
      hidden: doc.access!="editor",
    },
    {
      name: (
        <div className="flex items-center flex-row gap-2">
          <HiOutlineTrash className="text-red-500" />
          Delete
        </div>
      ),
      onClick: () => onDelete(doc.uuid),
      border: true,
      // hidden: doc.access !== "editor" && access !== "editor",
      hidden:  doc.access?doc.access !== "editor" : access !== "editor",
    },
    {
      name: (
        <div className="flex items-center flex-row gap-2">
          <IoShareSocial />
          Share
        </div>
      ),
      onClick: () => onShare(doc),
      border: false,
      hidden: doc.access!="editor",
    },
    {
      name: (
        <div className="flex items-center flex-row gap-2">
          <RxDownload />
          Download
        </div>
      ),
      onClick: () => onDownload(doc),
      border: false,
      hidden: doc.access,
    },
  ].filter((item) => !item?.hidden);

  return (
    <div
      className="absolute top-4 right-0 flex-center min-w-8"
      onClick={(e) => e.stopPropagation()}
    >
      <DropdownButton
        label=""
        items={[...dropdownItems]}
        trigger={
          <button className="text-primary-950 text-lg">
            <HiOutlineDotsVertical />
          </button>
        }
      />
    </div>
  );
};

export default FileAndFolderAction;
